import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import React__default from 'react';
import { api } from '@bilibili-maoer/web-utils';
import classNames from 'classnames';
import img$1 from '../assets/mgirl-notice/m-alone.png.js';
import img$2 from '../assets/mgirl-notice/m-magic.png.js';
import img from '../assets/mgirl-notice/m-notfound.png.js';
import img$3 from '../assets/mgirl-notice/m-sad.png.js';
import styles from './style/main.module.scss.js';

var _MGirlMap;
var EMGirlType;

(function (EMGirlType) {
  EMGirlType["NotFound"] = "m-notfound";
  EMGirlType["Alone"] = "m-alone";
  EMGirlType["Magic"] = "m-magic";
  EMGirlType["Sad"] = "m-sad";
})(EMGirlType || (EMGirlType = {}));

var MGirlMap = (_MGirlMap = {}, _defineProperty(_MGirlMap, EMGirlType.NotFound, img), _defineProperty(_MGirlMap, EMGirlType.Alone, img$1), _defineProperty(_MGirlMap, EMGirlType.Magic, img$2), _defineProperty(_MGirlMap, EMGirlType.Sad, img$3), _MGirlMap);
var MgirlNotice = function MgirlNotice(_ref) {
  var className = _ref.className,
      children = _ref.children,
      description = _ref.description,
      descriptionClassName = _ref.descriptionClassName,
      image = _ref.image,
      imageClassName = _ref.imageClassName,
      imageWithOpacity = _ref.imageWithOpacity;

  var renderImage = function renderImage() {
    if (typeof image === 'string') {
      // image 为 EMGirlType 时加载预设图片，其他情况直接将 image 作为 url 读取
      var imageUrl = MGirlMap[image] || image;
      return /*#__PURE__*/React__default.createElement("img", {
        src: api.ensureHttps(imageUrl),
        className: classNames(styles.image, _defineProperty({}, styles.opacity, imageWithOpacity), imageClassName)
      });
    }

    if ( /*#__PURE__*/React__default.isValidElement(image)) {
      return image;
    }

    return null;
  };

  var renderDescription = function renderDescription() {
    if (typeof description === 'string') {
      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames(styles.description, descriptionClassName)
      }, description);
    }

    if ( /*#__PURE__*/React__default.isValidElement(description)) {
      return description;
    }

    return null;
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles['mgirl-notice-container'], className)
  }, renderImage(), renderDescription(), children);
};

export { EMGirlType, MgirlNotice };
